import { styled } from "styled-components";

export const IconStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #383838;
  color: #fff;
  border-radius: 30px;
  cursor: pointer;
  font-size: 18px;
  margin-right: 24px;
  width: 45px;
  height: 45px;
`;
